<ion-content class="ion-no-padding">
  <form [formGroup]="invoiceForm" *ngIf="invoiceForm">
    <div class="lead-form model-container">
      <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
        <ion-toolbar class="header-first-toolbar">
          <div class="text-start ion-no-padding d-flex align-items-center gap-1">
            <span class="title-blue">{{editInvoiceId ? "Update Attached Invoice - " + editInvoiceId : "Attach Vendor Invoice"}}</span>
            <div class="input-container mb-0 d-flex align-items-center gap-1">
              <div class="">
                <label class="label">Currency</label>
              </div>
              <select class="input rounded-1 currency-input" formControlName="currencyCode">
                <option *ngFor="let item of currencyLov" [value]="item.key">{{item.name}}</option>
              </select>
            </div>
          </div>
          <ion-buttons slot="end" class="ion-no-margin">
            <ion-button class="filled-blue-btn" type="submit" (click)="onSubmit()">Save</ion-button>
            <ion-button class="unfilled-gray-btn" (click)="closeModal()">
              <ion-icon name="close-outline"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>

      <div class="model-content">
        <div class="dashed-line"></div>
        <div class="form-container">
          <div class="invoice-form-container">
            <div class="mb-1">
              <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Lead Details</ion-title>
            </div>

            <div class="ion-padding-horizontal">
              <div class="row">
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Lead*</label>
                    <div
                      [ngClass]="{ 'invalid-input': invoiceForm.get('lead')?.invalid && invoiceForm.get('lead')?.touched, 'empty-field': isFieldEmptyInForm('lead') }">
                      <app-relatedto-data-input [selectedType]="'Lead'" [searchOnlyLeads]="true"
                        (personData)="readClientDataOnSelect($event)"
                        formControlName="lead"></app-relatedto-data-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="my-1">
              <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Vendor Details</ion-title>
            </div>
            <div class="ion-padding-horizontal">
              <div class="row">
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Select From Vendor Contact</label>
                    <div
                      [ngClass]="{ 'invalid-input': invoiceForm.get('vendor')?.invalid && invoiceForm.get('vendor')?.touched, 'empty-field': isFieldEmptyInForm('vendor') }">
                      <app-vendor-search (vendorDataEmitter)="readSelectedVendor($event)"
                        formControlName="vendor"></app-vendor-search>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Email ID</label>
                    <div
                      [ngClass]="{ 'invalid-input': invoiceForm.get('email')?.invalid && invoiceForm.get('email')?.touched, 'empty-field': isFieldEmptyInForm('email') }">
                      <input type="text" class="input" placeholder="Email ID" formControlName="email">
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">First Name*</label>
                    <div
                      [ngClass]="{ 'invalid-input': invoiceForm.get('firstName')?.invalid && invoiceForm.get('firstName')?.touched, 'empty-field': isFieldEmptyInForm('firstName') }">
                      <input type="text" class="input" placeholder="First Name" formControlName="firstName">
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Last Name</label>
                    <div
                      [ngClass]="{ 'invalid-input': invoiceForm.get('lastName')?.invalid && invoiceForm.get('lastName')?.touched, 'empty-field': isFieldEmptyInForm('lastName') }">
                      <input type="text" class="input" placeholder="Last Name" formControlName="lastName">
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Organization Name*</label>
                    <div
                      [ngClass]="{ 'invalid-input': invoiceForm.get('organizationName')?.invalid && invoiceForm.get('organizationName')?.touched, 'empty-field': isFieldEmptyInForm('organizationName') }">
                      <input type="text" class="input" placeholder="Enter Organization Name" formControlName="organizationName">
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Phone Number*</label>
                    <div
                      [ngClass]="{ 'invalid-input': invoiceForm.get('phone')?.invalid && invoiceForm.get('phone')?.touched, 'empty-field': isFieldEmptyInForm('phone') }">
                      <app-phone-country-input formControlName="phone"></app-phone-country-input>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Service Type*</label>
                    <div
                      [ngClass]="{ 'invalid-input': invoiceForm.get('serviceType')?.invalid && invoiceForm.get('serviceType')?.touched, 'empty-field': isFieldEmptyInForm('serviceType') }">
                      <select class="input" formControlName="serviceType">
                        <option value="" hidden>--Select Service Type--</option>
                        <option *ngFor="let item of vendorServices" [value]="item.key">{{item.name}}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Address Lane 1</label>
                    <div
                      [ngClass]="{ 'invalid-input': invoiceForm.get('address1')?.invalid && invoiceForm.get('address1')?.touched, 'empty-field': isFieldEmptyInForm('address1') }">
                      <input type="text" class="input" placeholder="Address Lane 1" formControlName="address1">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="my-1">
              <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Invoice Details</ion-title>
            </div>
            <div class="ion-padding-horizontal">
              <div class="row mb-2">
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Invoice Number*</label>
                    <div
                      [ngClass]="{ 'invalid-input': invoiceForm.get('invoiceNumber')?.invalid && invoiceForm.get('invoiceNumber')?.touched, 'empty-field': isFieldEmptyInForm('invoiceNumber') }">
                      <input type="text" class="input" placeholder="Enter Invoice Number"
                        formControlName="invoiceNumber">
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Total Request Amount*</label>
                    <div
                      [ngClass]="{ 'invalid-input': invoiceForm.get('totalAmount')?.invalid && invoiceForm.get('totalAmount')?.touched, 'empty-field': isFieldEmptyInForm('totalAmount') }">
                      <app-select-text-input [prefix]="getCurrencyCode"
                        formControlName="totalAmount"></app-select-text-input>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Request Date*</label>
                    <div
                      [ngClass]="{ 'invalid-input': invoiceForm.get('invoiceDate')?.invalid && invoiceForm.get('invoiceDate')?.touched, 'empty-field': isFieldEmptyInForm('invoiceDate') }">
                      <app-date-picker [maxDate]="todayDate" formControlName="invoiceDate"></app-date-picker>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Payment Due Date*</label>
                    <div
                      [ngClass]="{ 'invalid-input': invoiceForm.get('dueDate')?.invalid && invoiceForm.get('dueDate')?.touched, 'empty-field': isFieldEmptyInForm('dueDate') }">
                      <app-date-picker [minDate]="invoiceForm.get('invoiceDate')?.value"
                        formControlName="dueDate"></app-date-picker>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="input-container">
                    <label for="" class="label">Attach Invoice Sent By Vendor* (Maximum 5 documents)</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('document')?.invalid && invoiceForm.get('document')?.touched, 'empty-field': isFieldEmptyInForm('document')  }">
                      <div class="document-chip-list" *ngIf="selectedDocuments.length">
                        <div class="document-chip" *ngFor="let doc of selectedDocuments; let i = index">
                          <button type="button" class="document-chip-text" (click)="openImage(doc)">
                            {{ getDocumentName(doc) }}
                          </button>
                          <button type="button" class="document-chip-close" (click)="removeDocument(i)" aria-label="Remove document">
                            <ion-icon name="close-outline"></ion-icon>
                          </button>
                        </div>
                      </div>
                      <div>
                        <input type="file" id="invoiceDocument" multiple class="input" accept=".png, .jpeg, .jpg, .webp, .docx, .pdf" placeholder="Choose Files"
                          (change)="onImageChanged($event)">
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</ion-content>